var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-header',{attrs:{"title":"ویرایش ویژگی محصول"}}),(_vm.specification)?_c('crud-generator',{attrs:{"fields":_vm.fields,"current-values":_vm.specification,"name":"specifications"},on:{"submit":_vm.submit}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }